<div class="form-group d-flex align-items-center small">
  <input
    class="form-check-input me-3"
    type="checkbox"
    [attr.id]="id"
    (change)="onChange()"
    [ngStyle]="{ 'height': bigCheckbox ? '22px' : '16px', 'width': bigCheckbox ? '22px' : '16px' }" />
  <label
    class="form-check-label"
    [attr.for]="id">
    <span>{{ label }}</span>
  </label>
</div>
